<template>
  <div class="performance-detail">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-content">
        <div class="title-wrapper">
          <h1>业绩详情</h1>
          <span class="subtitle">{{ adviserName }}</span>
        </div>
        <Button v-if="fromSalesDealRate" @click="goBack" icon="ios-arrow-back">返回销售成交率</Button>
        <Button v-else-if="fromChannelDealRate" @click="goBack" icon="ios-arrow-back">返回渠道成交率</Button>
        <Button v-else @click="goBack" icon="ios-arrow-back">返回龙虎榜</Button>
      </div>
    </div>
    <!-- 搜索条件 -->
    <Card class="search-card">
      <Form :model="queryParam" :label-width="80" inline>
        <Row>
          <Col  :xs="24" :sm="12" :md="6">
            <FormItem v-if="fromSalesDealRate || fromChannelDealRate" label="统计周">
              <span>{{ weekLabel }}</span>
            </FormItem>
            <FormItem v-else label="月份">
              <DatePicker
                type="month"
                format="yyyy-MM"
                placeholder="选择月份"
                :value="queryParam.month"
                @on-change="onMonthChange"
                style="width: 100%"
              />
            </FormItem>
          </Col>
          <Col  :xs="24" :sm="12" :md="6">
            <Button type="primary" @click="search" :loading="searchLoading">
              <Icon type="ios-search" /> 搜索
            </Button>
            <Button type="primary" :loading="exportLoading" @click="exportData" style="margin-left: 10px;">
              <Icon type="ios-download" /> 导出
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>

    <!-- 数据表格 -->
    <Card class="table-card">
      <div class="table-wrapper" v-if="tableData.length > 0">
        <table class="data-table">
          <thead>
            <tr>
              <th>成交日期</th>
              <th>报名时间</th>
              <th>学生ID</th>
              <th>姓名</th>
              <th>收费</th>
              <th>基础课时</th>
              <th>赠送课时</th>
              <th>师资</th>
              <th>成交外教</th>
              <th>课程顾问</th>
              <th>订单类型</th>
              <th>渠道</th>
              <th>转介绍</th>
              <th>转介绍学员班主任</th>
              <th>备注</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in tableData" :key="index">
              <td>{{ item.dealDate }}</td>
              <td>{{ item.signUpTime }}</td>
              <td>{{ item.userId }}</td>
              <td>{{ item.userName }}</td>
              <td>{{ $numeral(item.amount).format('0,0') }}</td>
              <td>{{ item.baseHours }}</td>
              <td>{{ item.giftHours }}</td>
              <td>{{ item.teacherType }}</td>
              <td>
                <Select
                  v-model="item.selectedTeacher"
                  @on-change="handleTeacherChange(item)"
                  placeholder="请选择老师"
                  style="width: 200px;"
                  transfer
                  :transfer-class-name="'performance-teacher-select'"
                >
                  <Option
                    v-for="teacher in item.trialLessonTeachers"
                    :key="teacher"
                    :value="teacher"
                  >
                    {{ teacher }}
                  </Option>
                </Select>
              </td>
              <td>{{ item.adviserName }}</td>
              <td :class="getChannelClass(item.channel)">{{ item.channel }}</td>
              <td>{{ item.regType }}</td>
              <td>{{ item.referralSC }}</td>
              <td>{{ item.referralSCName }}</td>
              <td>
                <Input
                  v-model="item.remark"
                  placeholder="请输入备注"
                  @on-change="handleRemarkChange(item)"
                  style="width: 200px;"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 空数据提示 -->
      <div v-if="tableData.length === 0 && !searchLoading" class="empty-data">
        <Icon type="ios-inbox" size="60" color="#dcdee2"/>
        <p>暂无数据</p>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: 'PerformanceDetail',
  data () {
    return {
      searchLoading: false,
      exportLoading: false,
      queryParam: {
        month: this.$moment().format('YYYY-MM'),
        adviserId: '',
        weekStart: '',
        startDate: '',
        endDate: '',
        weeks: 1,
        salesDealRate: null,
        channelDealRate: null,
        channelId: ''
      },
      fromSalesDealRate: false,
      fromChannelDealRate: false,
      adviserName: '',
      tableData: []
    }
  },
  computed: {
    weekLabel () {
      if (this.queryParam.startDate && this.queryParam.endDate && (this.fromSalesDealRate || this.fromChannelDealRate)) {
        return this.queryParam.startDate + ' ~ ' + this.queryParam.endDate
      }
      if (!this.queryParam.weekStart) {
        return ''
      }
      const start = this.$moment(this.queryParam.weekStart, 'YYYY-MM-DD')
      if (!this.fromSalesDealRate && this.fromChannelDealRate) {
        const weekStart = start.clone().startOf('isoWeek')
        const weekEnd = weekStart.clone().add(6, 'days')
        return weekStart.format('YYYY-MM-DD') + ' ~ ' + weekEnd.format('YYYY-MM-DD')
      }
      const days = this.fromSalesDealRate ? this.queryParam.weeks * 7 - 1 : 6
      const end = start.clone().add(days, 'days')
      return start.format('YYYY-MM-DD') + ' ~ ' + end.format('YYYY-MM-DD')
    }
  },
  created () {
    // 从路由参数获取 adviserId 和 month
    const adviserId = this.$route.query.adviserId
    const month = this.$route.query.month
    const salesDealRate = this.$route.query.salesDealRate
    const weekStart = this.$route.query.weekStart
    const channelDealRate = this.$route.query.channelDealRate
    const channelId = this.$route.query.channelId
    const startDate = this.$route.query.startDate
    const endDate = this.$route.query.endDate

    if (adviserId) {
      this.queryParam.adviserId = adviserId
    }
    if (month) {
      this.queryParam.month = month
    }
    if (salesDealRate == 1 || salesDealRate === '1') {
      this.fromSalesDealRate = true
      this.queryParam.salesDealRate = 1
      if (startDate && endDate) {
        this.queryParam.startDate = startDate
        this.queryParam.endDate = endDate
        this.queryParam.weekStart = startDate
      } else {
        const weeks = this.$route.query.weeks
        this.queryParam.weeks = String(weeks) === '8' ? 8 : 1
        if (weekStart) {
          this.queryParam.weekStart = weekStart
        }
      }
    }
    if (channelDealRate === 1 || channelDealRate === '1') {
      this.fromChannelDealRate = true
      this.queryParam.channelDealRate = 1
      if (startDate && endDate) {
        this.queryParam.startDate = startDate
        this.queryParam.endDate = endDate
        this.queryParam.weekStart = startDate
      } else if (weekStart) {
        this.queryParam.weekStart = weekStart
      }
      if (channelId !== undefined && channelId !== null && channelId !== '') {
        this.queryParam.channelId = channelId
      }
    }

    this.search()
  },
  methods: {
    onMonthChange (val) {
      this.queryParam.month = val
    },
    salesQueryParams () {
      const params = {
        salesDealRate: 1,
        adviserId: this.queryParam.adviserId
      }
      if (this.queryParam.startDate && this.queryParam.endDate) {
        params.startDate = this.queryParam.startDate
        params.endDate = this.queryParam.endDate
        params.weekStart = this.queryParam.startDate
      } else {
        params.weekStart = this.queryParam.weekStart
        params.weeks = this.queryParam.weeks
      }
      return params
    },
    channelQueryParams () {
      const params = {
        channelDealRate: 1,
        weekStart: this.queryParam.weekStart,
        channelId: this.queryParam.channelId
      }
      if (this.queryParam.startDate && this.queryParam.endDate) {
        params.startDate = this.queryParam.startDate
        params.endDate = this.queryParam.endDate
        params.weekStart = this.queryParam.startDate
      }
      return params
    },
    search () {
      this.searchLoading = true

      this.$http.get('/fundPackage/performanceDetail', {
        params: this.fromSalesDealRate ? this.salesQueryParams() : this.fromChannelDealRate ? this.channelQueryParams() : {
          month: this.queryParam.month,
          adviserId: this.queryParam.adviserId
        }
      }).then(res => {
        if (res && res.data) {
          this.processData(res.data)
        }
        this.searchLoading = false
      }).catch(() => {
        this.searchLoading = false
      })
    },
    processData (data) {
      if (!data) {
        this.tableData = []
        return
      }

      this.adviserName = data.adviserName || ''
      this.tableData = (data.list || []).map(item => {
        // 设置默认选中的老师为 foreignTeacher
        if (item.trialLessonTeachers && item.trialLessonTeachers.length > 0) {
          // 如果 foreignTeacher 在老师数组中，则设置为默认值
          item.selectedTeacher = item.trialLessonTeachers.includes(item.foreignTeacher)
            ? item.foreignTeacher
            : null
        } else {
          item.selectedTeacher = null
        }
        return item
      })
    },
    goBack () {
      if (this.fromSalesDealRate) {
        const startDate = this.queryParam.startDate
        const endDate = this.queryParam.endDate
        let query
        if (startDate && endDate) {
          query = {
            startDate: startDate,
            endDate: endDate
          }
        } else {
          query = {
            weekStart: this.queryParam.weekStart || this.$route.query.weekStart,
            weeks: this.queryParam.weeks || this.$route.query.weeks
          }
        }
        this.$router.push({
          path: '/crm/SalesDealRate',
          query: query
        })
        return
      }
      if (this.fromChannelDealRate) {
        const startDate = this.queryParam.startDate
        const endDate = this.queryParam.endDate
        let query
        if (startDate && endDate) {
          query = {
            startDate: startDate,
            endDate: endDate
          }
        } else {
          query = {
            weekStart: this.queryParam.weekStart || this.$route.query.weekStart
          }
        }
        if (this.$route.query.marketCategory) {
          query.marketCategory = this.$route.query.marketCategory
        }
        this.$router.push({
          path: '/market/ChannelDealRate',
          query: query
        })
        return
      }
      this.$router.push({ path: '/order/dragonTigerListV2' })
    },
    getChannelClass (channel) {
      if (!channel) return ''
      if (channel.includes('市场')) return 'channel-market'
      if (channel.includes('转介绍')) return 'channel-referral'
      if (channel.includes('结课新签')) return 'channel-renew'
      return ''
    },
    getFunctionClass (functionCover) {
      if (!functionCover) return ''
      if (functionCover.includes('补升')) return 'function-upgrade'
      if (functionCover.includes('续费')) return 'function-renew'
      return ''
    },
    handleRemarkChange (item) {
      // 防抖处理，避免频繁调用
      if (item.saveTimer) clearTimeout(item.saveTimer)
      item.saveTimer = setTimeout(() => {
        this.saveRemark(item)
      }, 500)
    },
    async saveRemark (item) {
      if (!item.fundPackageId) {
        this.$Message.warning('缺少 fundPackageId，无法保存')
        return
      }

      try {
        await this.$http.post('/fundPackage/updateRemark', {
          fundPackageId: item.fundPackageId,
          remark: item.remark || ''
        })
        this.$Message.success('备注已保存')
      } catch (error) {
        this.$Message.error('保存失败，请重试')
      }
    },
    handleTeacherChange (item) {
      // 防抖处理，避免频繁调用
      if (item.teacherTimer) clearTimeout(item.teacherTimer)
      item.teacherTimer = setTimeout(() => {
        this.saveForeignTeacher(item)
      }, 500)
    },
    async saveForeignTeacher (item) {
      if (!item.fundPackageId) {
        this.$Message.warning('缺少 fundPackageId，无法保存')
        return
      }

      // 获取选中的老师名字
      const selectedTeacherName = item.selectedTeacher
      if (!selectedTeacherName) {
        this.$Message.warning('未选择老师')
        return
      }

      try {
        await this.$http.post('/fundPackage/updateRemark', {
          fundPackageId: item.fundPackageId,
          demoTch: selectedTeacherName || ''
        })
        // 暂时更新本地数据
        item.foreignTeacher = selectedTeacherName
        this.$Message.success('成交外教已更新')
      } catch (error) {
        this.$Message.error('更新失败，请重试')
      }
    },
    exportData () {
      this.exportLoading = true

      this.$http.get('/fundPackage/performanceDetail/export', {
        responseType: 'arraybuffer',
        params: this.fromSalesDealRate ? this.salesQueryParams() : this.fromChannelDealRate ? this.channelQueryParams() : {
          month: this.queryParam.month,
          adviserId: this.queryParam.adviserId
        }
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          const suffix = this.fromSalesDealRate || this.fromChannelDealRate
            ? (this.queryParam.startDate || this.queryParam.weekStart)
            : this.queryParam.month
          link.download = `业绩详情-${this.adviserName}-${suffix}.xlsx`
          link.click()
          this.$Message.success('导出成功')
        } else {
          this.$Message.error(response.msg || '导出失败')
        }
        this.exportLoading = false
      }).catch((error) => {
        this.$Message.error('导出失败：' + error.message)
        this.exportLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.performance-detail {
  min-height: 100%;
  background: #f0f2f5;
  padding: 20px;
}

// 页面头部
.page-header {
  background: linear-gradient(135deg, #ff9900 0%, #ffb347 100%);
  border-radius: 12px;
  padding: 8px 12px;
  margin-bottom: 5px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;

    h1 {
      margin: 0;
      font-size: 28px;
      font-weight: 700;
      color: #fff;
      letter-spacing: 1px;
    }

    .subtitle {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.9);
      padding: 6px 16px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 20px;
    }
  }

  button {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: #fff;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
}

// 表格卡片
.table-card {
  margin-top: 5px;

  .table-wrapper {
    overflow-x: auto;
  }

  .data-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    thead {
      tr {
        background: rgba(243, 239, 18, 0.87);
        color: #000;

        th {
          padding: 14px 12px;
          text-align: center;
          font-weight: 600;
          white-space: nowrap;
          border: none;
        }
      }
    }

    tbody {
      tr {
        transition: all 0.3s ease;

        &:hover {
          background: #f6f8fa;
          transform: scale(1.005);
        }

        td {
          padding: 12px;
          text-align: center;
          border-bottom: 1px solid #e8e8e8;
          white-space: nowrap;
        }
      }
    }

    // 渠道选项样式
    .channel-market {
      color: #2d8cf0;
      font-weight: 600;
    }

    .channel-referral {
      color: #19be6b;
      font-weight: 600;
    }

    .channel-renew {
      color: #ff9900;
      font-weight: 600;
    }

    // 函数覆盖样式
    .function-upgrade {
      color: #f5576c;
      font-weight: 600;
    }

    .function-renew {
      color: #4facfe;
      font-weight: 600;
    }
  }

  .empty-data {
    text-align: center;
    padding: 60px 20px;
    color: #999;

    p {
      margin-top: 16px;
      font-size: 16px;
    }
  }
}

// 搜索条件卡片
.search-card {
  padding: 5px;
  margin-bottom: 5px;

  /deep/ .ivu-form-item {
    margin-bottom: 5px;
  }

  /deep/ .ivu-form-item-label {
    padding-right: 5px;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .page-header {
    padding: 16px 20px;

    .title-wrapper {
      h1 {
        font-size: 22px;
      }
    }
  }

  .data-table {
    font-size: 13px;

    th, td {
      padding: 8px 6px;
    }
  }
}

// 下拉框层级优化（transfer 挂载到 body 上）
/deep/ .performance-teacher-select {
  z-index: 9999 !important;
}
</style>



// WEBPACK FOOTER //
// PerformanceDetail.vue?72c96caa